;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller('csVulnerabilityBugtrackerCtrl', csVulnerabilityBugtrackerCtrl)

  function csVulnerabilityBugtrackerCtrl(VULN_STATUS_TYPE) {
    'ngInject'

    var vm
    this.$onInit = function () {
      vm = this
      angular.extend(vm, {
        getStyle: getStyle,
        hasBugtrackers: hasBugtrackers,
        getPlacement: getPlacement
      })
    }

    function getStyle(status) {
      if (
        angular.isString(status) &&
        (status === VULN_STATUS_TYPE.CONFIRMED ||
          status === VULN_STATUS_TYPE.REPORTED ||
          status === VULN_STATUS_TYPE.SUSPICIOUS)
      ) {
        return 'white'
      }
      return 'color-gray-light-middle'
    }

    function hasBugtrackers() {
      return angular.isArray(vm.bugtrackers) && vm.bugtrackers.length > 0
    }

    function getPlacement() {
      return angular.isString(vm.placement) ? vm.placement : 'bottom'
    }
  }
})()
